export default "__VITE_ASSET__5HsX02uS__"